/**
 * IMPORTS
 */

import { IAtualizarModeloPayload } from "@/hooks/modelos/atualizar-modelo/index.d";

import { fixasRepository } from "@/repositories/modelos";

/**
 * Função que busca dados de fixas tecnicas 🛠️.
 */
const handleGetModelos = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await fixasRepository.getAllModelos(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR MODELOS: ", error);

    return error;
  }
};

/**
 * Função que busca todos os modelo de um cliente 🛠️.
 */
const handleGetModelosPorCliente = async (
  accessToken: string,
  user_cliente_id: number,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string,
  incluirInativos = false
) => {
  try {
    const data = await fixasRepository.getAllModelosPorCliente(
      accessToken,
      user_cliente_id,
      currentPage,
      itemsPerPage,
      searchItem,
      incluirInativos
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR MODELOS DE CLIENTE: ", error);

    return error;
  }
};

/**
 * Função que busca um modelo técnico específico de um cliente 🛠️.
 */
const handleGetModeloUnicoDoCliente = async (
  accessToken: string,
  modelo_id: number,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await fixasRepository.getModeloUnicoDoCliente(
      accessToken,
      modelo_id,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR UM MODELO ESPECIFICO DE CLIENTE: ", error);

    return error;
  }
};

/**
 * Função que criar um novo modelo de crachá para cliente 🛠️.
 */
const handleCriarNovoModelo = async (accessToken: string, payload: any) => {
  try {
    const modeloCriado = await fixasRepository.criarNovoModelo(accessToken, payload);

    return modeloCriado;
  } catch (error: any) {
    console.log("ERROR AO CRIAR MODELO: ", error);

    return error;
  }
};

/**
 * Função atualizar modelo de crachá para cliente 🛠️.
 */
const handleAtualizarModelo = async (
  accessToken: string,
  modelo_id: number,
  payload: IAtualizarModeloPayload
) => {
  try {
    const modeloAtualizado = await fixasRepository.atualizarModelo(accessToken, modelo_id, payload);

    return modeloAtualizado;
  } catch (error: any) {
    console.log("ERROR AO ATUALIZAR MODELO: ", error);

    return error;
  }
};

/**
 * Função inativar modelo de crachá para cliente 🛠️.
 */
const handleInativarModelo = async (accessToken: string, modelo_id: number) => {
  try {
    const modeloAtualizado = await fixasRepository.inativarModelo(accessToken, modelo_id);

    return modeloAtualizado;
  } catch (error: any) {
    console.log("ERROR AO INATIVAR MODELO: ", error);

    throw error;
  }
};

/**
 * Função reativar modelo de crachá inativado 🛠️.
 */
const handleReativarModelo = async (accessToken: string, modelo_id: number) => {
  try {
    const modeloAtualizado = await fixasRepository.reativarModelo(accessToken, modelo_id);

    return modeloAtualizado;
  } catch (error: any) {
    console.log("ERROR AO REATIVAR MODELO: ", error);

    throw error;
  }
};

/**
 * Função que criar campos variaveis para o modelo 🛠️.
 */
const handleCriarCamposVariaveis = async (accessToken: string, payload: any) => {
  try {
    const camposVarivaiesCriado = await fixasRepository.criarCamposVariaveisModelo(
      accessToken,
      payload
    );

    return camposVarivaiesCriado;
  } catch (error: any) {
    console.log("ERROR AO CRIAR CAMPOS VARIAVEIS MODELO: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export {
  handleAtualizarModelo,
  handleCriarCamposVariaveis,
  handleCriarNovoModelo,
  handleGetModelos,
  handleGetModelosPorCliente,
  handleGetModeloUnicoDoCliente,
  handleInativarModelo,
  handleReativarModelo,
};
